import React, { useMemo, useState, useEffect } from 'react';
import cn from '@/utils/cn';
import AccountBalance from './AccountBalance';
import AccountCardGroup from './AccountCardGroup';
import useHomeContext from '@/hooks/useHomeContext';
import { ALL_ACCOUNTS } from '@/context/HomeProvider/HomeContextProvider';
import moment from 'moment';
import { ascending } from '@/utils/sortBy';

const LeftSideClassName = cn(['flex', 'flex-1', 'items-start']);

interface BankAccountsProps {}

const BankAccounts: React.FC<BankAccountsProps> = () => {
  const { selectedAccount, bankAccount, wallets } = useHomeContext()!;
  const [showAllAccounts, setShowAllAccounts] = useState(selectedAccount.value === ALL_ACCOUNTS);

  useEffect(() => {
    if (selectedAccount.value === ALL_ACCOUNTS) {
      setShowAllAccounts(true);
    }
  }, [selectedAccount.value]);

  const bankAccounts = useMemo(
    () => wallets.sort((a, b) => ascending(moment(a.created).unix(), moment(b.created).unix())),
    [wallets]
  );

  const handleShowAllAccountsToggle = () => {
    setShowAllAccounts((prev) => !prev);
  };

  return (
    <div className="pt-3 pb-9">
      {bankAccount ? (
        <div className="flex flex-col gap-y-9">
          <div className="flex">
            <div className={LeftSideClassName}>
              <h2 className="text-emerge-navy font-medium text-2xl">{selectedAccount?.label}</h2>
            </div>
          </div>
          <div className="flex flex-row">
            <AccountBalance
              selectedAccount={bankAccount}
              showAllAccounts={showAllAccounts}
              isAllAccounts={selectedAccount.value === ALL_ACCOUNTS}
              onShowAllAccountsToggle={handleShowAllAccountsToggle}
            />
            {showAllAccounts ? <AccountCardGroup options={bankAccounts} /> : null}
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default BankAccounts;
